export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public code: string,
    public retryable: boolean = status >= 500 || status === 408
  ) {
    super(message);
    this.name = 'ApiError';
  }

  static isRetryable(error: unknown): boolean {
    if (error instanceof ApiError) {
      return error.retryable;
    }
    // Network errors are retryable
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      return true;
    }
    return false;
  }

  static fromError(error: unknown): ApiError {
    if (error instanceof ApiError) {
      return error;
    }
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      return new ApiError(
        'Network error, please check your connection',
        0,
        'NETWORK_ERROR',
        true
      );
    }
    if (error instanceof Error) {
      return new ApiError(
        error.message,
        0,
        'UNKNOWN_ERROR',
        false
      );
    }
    return new ApiError(
      'An unknown error occurred',
      0,
      'UNKNOWN_ERROR',
      false
    );
  }
}